<template>
  <v-dialog v-model="visible" max-width="800px">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-form>
          <v-row dense>
            <v-col cols="12">
              <div class="d-flex">
                <v-switch
                  style="margin-top: -4px"
                  v-model="form.verificarSolicitudesPagosCuotaAnterior"
                  hide-details
                  label="Verificar Solicitudes Pagos Cuota Anterior"></v-switch>
              </div>
            </v-col>

            <v-col cols="12">
              <div class="d-flex">
                <v-switch
                  style="margin-top: -4px"
                  v-model="form.verificarPagosCuotaAnterior"
                  hide-details
                  label="Verificar Pagos Cuota Anterior"></v-switch>
              </div>
            </v-col>

            <v-col cols="12">
              <div class="d-flex">
                <v-switch
                  style="margin-top: -4px"
                  v-model="form.verificarSolicitudesPagosEstadoActual"
                  hide-details
                  label="Verificar Solicitudes Pagos Estado Actual"></v-switch>
              </div>
            </v-col>

            <v-col cols="12">
              <v-select
                v-model="form.tipoVerificacionSolicitudesPagos"
                class="mt-4"
                :items="tiposVerificacionSolicitudesPagos"
                label="Tipo de verificación de solicitudes de pagos"
                placeholder="Seleccione un tipo de verificación"
                outlined
                dense
                hide-details />
            </v-col>

            <v-col cols="12">
              <v-select
                v-model="form.numeroModuloMinimoParaInscripcionUniversidad"
                class="mt-4"
                :items="[
                  { text: 'Ninguno', value: null },
                  ...Array.from({ length: 20 }, (_, i) => i + 1).map((num) => {
                    return { text: num.toString(), value: num };
                  }),
                ]"
                label="Número de módulo mínimo para inscripción en universidad"
                placeholder="Seleccione un número de módulo"
                outlined
                dense
                hide-details />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text :disabled="enviando" @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn color="blue darken-1" text :disabled="enviando" :loading="enviando" @click.prevent="guardar">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import modalFormMixin from '../mixins/modal-form.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import ConfiguracionesService from '../services/configuraciones.service';
import { TIPO_VERIFICACION_SOLICITUDES_PAGOS } from '../utils/constantes';

export default {
  name: 'ModalFormularioConfiguracionesPagos',
  mixins: [modalFormMixin, apiConsumerMixin],
  props: {
    universidadId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      configuracion: null,
      accion: null,
      tiposVerificacionSolicitudesPagos: Object.values(TIPO_VERIFICACION_SOLICITUDES_PAGOS).map((item) => {
        return { text: item.toUpperCase(), value: item };
      }),
    };
  },
  watch: {
    'form.verificarPagosCuotaAnterior': function () {
      this.errores.verificarPagosCuotaAnterior = [];
    },
    'form.verificarSolicitudesPagosCuotaAnterior': function () {
      this.errores.verificarSolicitudesPagosCuotaAnterior = [];
    },
    'form.verificarSolicitudesPagosEstadoActual': function () {
      this.errores.verificarSolicitudesPagosEstadoActual = [];
    },
    'form.tipoVerificacionSolicitudesPagos': function () {
      this.errores.tipoVerificacionSolicitudesPagos = [];
    },
    'form.numeroModuloMinimoParaInscripcionUniversidad': function () {
      this.errores.numeroModuloMinimoParaInscripcionUniversidad = [];
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        verificarPagosCuotaAnterior: false,
        verificarSolicitudesPagosCuotaAnterior: false,
        verificarSolicitudesPagosEstadoActual: false,
        tipoVerificacionSolicitudesPagos: TIPO_VERIFICACION_SOLICITUDES_PAGOS.POR_CONCEPTO,
        numeroModuloMinimoParaInscripcionUniversidad: null,
        universidadId: this.universidadId,
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        verificarPagosCuotaAnterior: data.verificarPagosCuotaAnterior,
        verificarSolicitudesPagosCuotaAnterior: data.verificarSolicitudesPagosCuotaAnterior,
        verificarSolicitudesPagosEstadoActual: data.verificarSolicitudesPagosEstadoActual,
        tipoVerificacionSolicitudesPagos: data.tipoVerificacionSolicitudesPagos,
        numeroModuloMinimoParaInscripcionUniversidad: data.numeroModuloMinimoParaInscripcionUniversidad,
        universidadId: data.universidadId,
      };
    },
    abrir() {
      this.obtenerConfiguracion().then(() => {
        const accion = this.configuracion?.id ? this.accionesCrud.EDITAR : this.accionesCrud.REGISTRAR;
        this.accion = accion;

        this.abrirMixin(accion, this.configuracion);
      });
    },
    obtenerConfiguracion() {
      return this.obtenerDatosV2Mixin(
        ConfiguracionesService.findByUniversidadId,
        'configuracion',
        this.universidadId,
        () => {
          this.configuracion = this.configuracion || null;
        },
      );
    },
    async guardar() {
      await this.guardarDatosMixin(
        ConfiguracionesService.create,
        ConfiguracionesService.update,
        this.accion,
        this.form,
        'Plan Pago Concepto Universidad',
        () => {
          this.cerrar();
        },
        (errores) => {
          this.errores = errores;
        },
      );
    },
  },
};
</script>